export const DS_ICON_PICKER_CLASSES = {
  Root: "ds-icon-picker",
} as const;

export const DS_ICON_PICKER_LIST_CLASSES = {
  Root: "ds-icon-picker-list",
  Panel: "ds-icon-picker-list__panel",
  Categories: "ds-icon-picker-list__categories",
  Category: "ds-icon-picker-list__category",
  Search: "ds-icon-picker-list__search",
  Grid: "ds-icon-picker-list__grid",
  Empty: "ds-icon-picker-list__empty",
} as const;
